"use client";

import React from "react";
import { Facebook, Instagram, Mail, MapPin, Phone, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="space-y-3">
        {[1, 2, 3].map((_, i) => <div key={i} data-index={i} className="h-5 w-24 animate-pulse rounded-md bg-muted" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    const fallbackLinks = [{
      id: "fallback-1",
      label: "Our Sires",
      href: "/OurCavaliersPage"
    }, {
      id: "fallback-2",
      label: "Our Dams",
      href: "/OurCavaliersPage"
    }, {
      id: "fallback-3",
      label: "Available Puppies",
      href: "/ShopPage"
    }];
    return <ul className="space-y-3">
        {fallbackLinks.map((item, i) => <li key={item.id} data-index={i}>
            <Link to={item.href} className="font-sans text-muted-foreground transition-colors hover:text-primary">
              {item.label}
            </Link>
          </li>)}
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="font-sans text-muted-foreground transition-colors hover:text-primary">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const socialLinks = [{
    icon: Facebook,
    href: "https://facebook.com/diana.cook.56679",
    label: "Facebook"
  }, {
    icon: Instagram,
    href: "https://instagram.com/cobrnik",
    label: "Instagram"
  }];
  return <section id="footer" className="bg-background pt-20 pb-10">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-16 grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-4 lg:gap-8">
          {}
          <div className="flex flex-col items-start space-y-6">
            <Link to="/" className="inline-block">
              <img src="https://cobrnik.com/wp-content/uploads/2026/04/cobrnik_cavaliers_logo.png" alt="Cobrnik Cavaliers Logo" className="h-7 w-auto object-contain" />
            </Link>
            <p className="font-sans text-sm leading-relaxed text-muted-foreground">
              We are an ethical, AKC Breeder of Merit for Cavalier King Charles Spaniels, dedicated
              to health, temperament, and preserving the royal heritage of this elegant breed.
            </p>
          </div>

          {}
          <div>
            <h3 className="mb-6 font-serif text-lg font-medium text-foreground">Quick Links</h3>
            <MenuProvider menu_id="50">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="mb-6 font-serif text-lg font-medium text-foreground">Contact Us</h3>
            <ul className="space-y-4"><li className="flex items-start gap-3" data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:3640v9" data-ast-start="3330" data-ast-end="3558"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-phone mt-0.5 size-5 shrink-0 text-muted-foreground" aria-hidden="true" data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:6ukjw4" data-ast-start="3386" data-ast-end="3452"><path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384"></path></svg><span className="font-sans text-muted-foreground" data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:v3367y" data-ast-start="3469" data-ast-end="3538" contenteditable="false" style={{}}>435-790-4987</span></li><li className="flex items-start gap-3" data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:3640va" data-ast-start="3573" data-ast-end="3959"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-mail mt-0.5 size-5 shrink-0 text-muted-foreground" aria-hidden="true" data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:j2jtds" data-ast-start="3629" data-ast-end="3694"><path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path><rect x="2" y="4" width="20" height="16" rx="2"></rect></svg><Link to="mailto:dianacook@icloud.com" className="font-sans text-muted-foreground transition-colors hover:text-primary">dianacook@icloud.com</Link></li><li className="flex items-start gap-3" data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:3640vb" data-ast-start="3974" data-ast-end="4323"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-map-pin mt-0.5 size-5 shrink-0 text-muted-foreground" aria-hidden="true" data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:tg0tl0" data-ast-start="4030" data-ast-end="4097"><path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path><circle cx="12" cy="10" r="3"></circle></svg><span className="font-sans text-muted-foreground" data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:v3367y" data-ast-start="4114" data-ast-end="4303">2512 North 500 East  Vernal, Utah 84078<br />
              </span></li></ul>
          </div>
        </div>

        <Separator className="mb-8 bg-border/60" />

        {}
        <div className="flex flex-col items-center justify-between gap-4 md:flex-row">
          <div className="flex items-center gap-4">
            {socialLinks.map((social, i) => {
            const Icon = social.icon;
            return <Link key={i} data-index={i} to={social.href} className="rounded-full bg-muted/50 p-2 text-muted-foreground transition-colors hover:bg-primary/10 hover:text-primary" aria-label={social.label}>
                  <Icon className="size-4" />
                </Link>;
          })}
          </div>
          <p className="font-sans text-sm text-muted-foreground">
            &copy; {currentYear} Cobrnik Cavaliers. All rights reserved.
          </p>
        </div>
      </div>
    </section>;
}